import { CONSULT_SURVEY, CONTACT_URL } from '../data/url';
import img_line from '../assets/img_line.svg';

import './FloatingButton.css';
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}
export const ConsultButton = () => {
    const handleContactClick = (e: any) => {
        e.preventDefault(); // 阻止預設跳轉
        if (window.gtag_report_conversion) {
            window.gtag_report_conversion(CONSULT_SURVEY);
        }
        setTimeout(() => {
            window.open(CONSULT_SURVEY, '_blank', 'noopener,noreferrer');
        }, 100);
    };
    return (
        <div className='consult_button'>
            <a href={CONSULT_SURVEY} target='_blank' rel='nooperer noreferrer' onClick={handleContactClick}>
                洽詢企業方案
            </a>
        </div>
    );
};

export const ContactButton = () => {
    return (
        <div className='contact_button'>
            <a href={CONTACT_URL} target='_blank' rel='nooperer noreferrer'>
                <img src={img_line} alt='img_line'/>
                聯絡我們
            </a>
        </div>
    );
};
